import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  // Prevent body scroll when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-166">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/40 backdrop-blur-sm z-50 flex items-center justify-center p-4" data-id="element-167">
            {/* Modal Content */}
            <motion.div initial={{
          scale: 0.95,
          opacity: 0,
          y: 20
        }} animate={{
          scale: 1,
          opacity: 1,
          y: 0
        }} exit={{
          scale: 0.95,
          opacity: 0,
          y: 20
        }} onClick={e => e.stopPropagation()} className="bg-white rounded-2xl shadow-xl w-full max-w-2xl max-h-[80vh] flex flex-col overflow-hidden relative" data-id="element-168">
              <div className="p-6 border-b border-pink-100 flex justify-between items-center bg-pink-50/50" data-id="element-169">
                <h3 className="text-xl font-bold text-gray-800" data-id="element-170">{title}</h3>
                <button onClick={onClose} className="p-2 hover:bg-pink-100 rounded-full transition-colors text-gray-500 hover:text-gray-700" aria-label="Cerrar" data-id="element-171">
                  <X size={20} data-id="element-172" />
                </button>
              </div>

              <div className="p-6 overflow-y-auto custom-scrollbar" data-id="element-173">
                <div className="prose prose-pink max-w-none text-gray-600" data-id="element-174">
                  {children}
                </div>
              </div>

              <div className="p-4 border-t border-pink-100 bg-gray-50 flex justify-end" data-id="element-175">
                <button onClick={onClose} className="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-800 rounded-lg text-sm font-medium transition-colors" data-id="element-176">
                  Cerrar
                </button>
              </div>
            </motion.div>
          </motion.div>
        </>}
    </AnimatePresence>;
}